// src/reducers/likeDislikeReducer.js

import {
    GET_ALL_LIKES_REQUEST,
    GET_ALL_LIKES_SUCCESS,
    GET_ALL_LIKES_FAIL,
    GET_ONE_LIKE_REQUEST,
    GET_ONE_LIKE_SUCCESS,
    GET_ONE_LIKE_FAIL,
    CREATE_LIKE_REQUEST,
    CREATE_LIKE_SUCCESS,
    CREATE_LIKE_FAIL,
    UPDATE_LIKE_REQUEST,
    UPDATE_LIKE_SUCCESS,
    UPDATE_LIKE_FAIL,
    DELETE_LIKE_REQUEST,
    DELETE_LIKE_SUCCESS,
    DELETE_LIKE_FAIL,
    RESET_LIKE_STATE,
    // --- IMPORT NEW ACTION TYPES ---
    GET_LIKES_BY_PATIENT_REQUEST,
    GET_LIKES_BY_PATIENT_SUCCESS,
    GET_LIKES_BY_PATIENT_FAIL
} from '../actions/types';

const initialState = {
    likeDislikes: [],    // Array of all like/dislike records for a doctor profile
    likeDislike: null,   // A single record (e.g., the current user's vote on a profile)
    patientLikes: [],    // --- NEW: Array of likes made by the logged-in patient (for Favourites page) ---
    loading: false,
    error: null,
    success: false       // Useful for triggering UI feedback
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ALL_LIKES_REQUEST:
        case GET_ONE_LIKE_REQUEST:
        case CREATE_LIKE_REQUEST:
        case UPDATE_LIKE_REQUEST:
        case DELETE_LIKE_REQUEST:
        // --- ADD NEW REQUEST CASE ---
        case GET_LIKES_BY_PATIENT_REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                error: null
            };

        case GET_ALL_LIKES_SUCCESS:
            return {
                ...state,
                loading: false,
                likeDislikes: payload,
            };
            
        case GET_ONE_LIKE_SUCCESS:
            return {
                ...state,
                loading: false,
                likeDislike: payload,
            };

        // --- ADD NEW SUCCESS CASE ---
        case GET_LIKES_BY_PATIENT_SUCCESS:
            return {
                ...state,
                loading: false,
                patientLikes: payload, // Populate the new state property
            };

        case CREATE_LIKE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                likeDislikes: [...state.likeDislikes, payload],
            };

        case UPDATE_LIKE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                likeDislikes: state.likeDislikes.map(item => 
                    item.id === payload.id ? payload : item
                ),
                likeDislike: state.likeDislike?.id === payload.id ? payload : state.likeDislike,
            };

        case DELETE_LIKE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                likeDislikes: state.likeDislikes.filter(item => item.id !== payload),
                likeDislike: state.likeDislike?.id === payload ? null : state.likeDislike,
            };
        
        case GET_ALL_LIKES_FAIL:
        case GET_ONE_LIKE_FAIL:
        case CREATE_LIKE_FAIL:
        case UPDATE_LIKE_FAIL:
        case DELETE_LIKE_FAIL:
        // --- ADD NEW FAIL CASE ---
        case GET_LIKES_BY_PATIENT_FAIL:
            return {
                ...state,
                loading: false,
                error: payload
            };
            
        case RESET_LIKE_STATE:
             return {
                ...state,
                // Also reset the new state property if needed
                patientLikes: state.patientLikes, // Or [] if it should be cleared
                loading: false,
                error: null,
                success: false
             };

        default:
            return state;
    }
}